module.exports = __webpack_public_path__ + "img/5.57b0f8b1.png";